import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Button from "@template/components/Button";
import styles from "../NewsletterSignupForm.deferred.css";

const AccountExistsMessage = ({
  onOptIn,
  onUseDifferentEmail,
  formatTranslation
}) => {
  const messageRef = useRef(null);

  useEffect(() => {
    messageRef.current?.focus();
  }, []);

  return (
    <>
      <h3
        ref={messageRef}
        tabIndex={-1}
        data-testid="newsletter-account-exists-message"
        className={styles.feedbackMessageTitle}
      >
        {formatTranslation("footer_newsletter_existing_account_title")}
      </h3>
      <p className={styles.feedbackMessage}>
        {formatTranslation("footer_newsletter_existing_account_body")}
      </p>
      <div className={styles.accountExistsButtons}>
        <div className={styles.submitButtonContainer}>
          <Button
            data-testid="newsletter-opt-in-button"
            theme="primary"
            classes={styles.submitButton}
            onClick={onOptIn}
          >
            {formatTranslation("footer_newsletter_existing_account_cta")}
          </Button>
        </div>
        <div className={styles.submitButtonContainer}>
          <Button
            data-testid="newsletter-use-different-email-button"
            theme="primary"
            classes={styles.submitButton}
            onClick={onUseDifferentEmail}
          >
            {formatTranslation(
              "footer_newsletter_existing_account_alternative_cta"
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

AccountExistsMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  onOptIn: PropTypes.func.isRequired,
  onUseDifferentEmail: PropTypes.func.isRequired
};

export default AccountExistsMessage;
